// K2D "Riportok -> Könyvelési események" (w_popup_report_konyv_esemeny) modelljei.

export interface BookingEventsLookupItem {
  id: number;
  name: string;
  // Rövid kód (csbokbooktype.nicname, pl. KI/BE) — csak naplótípusnál töltött.
  nicName: string | null;
  // Alapból kiválasztott-e (K2D: naplótípusnál mind, állapotnál csak a szam < 6 kódúak).
  defaultSelected: boolean;
}

export interface BookingEventsLookups {
  bookTypes: BookingEventsLookupItem[];
  statuses: BookingEventsLookupItem[];
}

// Tranzakció-választó elem a TR-intervallum lookuphoz (hxboktrans szam + gazdasági esemény).
export interface BookingEventsTransactionLookup {
  id: number;
  accEvent: string;
}

// Két kizáró ág: ha van tranzakció-azonosító intervallum, csak az érvényesül;
// egyébként a dátum + állapot + naplótípus szűrők.
export interface BookingEventsRequest {
  accDateFrom: string | null;
  accDateTo: string | null;
  bookingDateFrom: string | null;
  bookingDateTo: string | null;
  transIdFrom: number;
  transIdTo: number;
  withStorno: boolean;
  withModified: boolean;
  // Rendezés szállító + külső számlaszám szerint (K2D rb_sort_szall) — csak szállítói (GENI) tételek.
  sortBySupplier: boolean;
  statusIds: number[];
  bookTypeIds: number[];
}

export const DefaultBookingEventsRequest: BookingEventsRequest = {
  accDateFrom: null,
  accDateTo: null,
  bookingDateFrom: null,
  bookingDateTo: null,
  transIdFrom: 0,
  transIdTo: 0,
  withStorno: false,
  withModified: false,
  sortBySupplier: false,
  statusIds: [],
  bookTypeIds: [],
};

export interface BookingEventsPdfResult {
  success: boolean;
  message: string;
  pdf: string | null;
}
